<template>
    <div :class="['header-wrap', {'p-b-20': !showNav}, {'fixHeader': fixHeader}]">
        <div class="header">
            <div class="left" @click="goHome">
                <img src="../assets/imgs/logo.png" />
                <span>丨</span>
                <b>平台教程</b>
            </div>
            <div class="right" style="width: 40%;">
                <!-- <el-input
                    placeholder="请输入想要查找的内容"
                    v-model="input"
                    @keyup.enter.native="searchArticle"
                >
                    <el-button slot="append" @click="searchArticle">搜索</el-button>
                </el-input> -->
                <el-autocomplete
                    class="inline-input"
                    v-model="input"
                    :fetch-suggestions="queryAssociatelFn"
                    placeholder="请输入内容"
                    @select="handleSelect"
                    @keyup.enter.native="searchArticle"
                ><el-button slot="append" @click="searchArticle">搜索</el-button></el-autocomplete>
            </div>
        </div>
        <div class="ak-nav" v-if="showNav">
            <ul class="nav">
                <li v-for="item in courseType" :key="item.code" @click="routerList(item.code)">
                    <span :class="{'is-active': item.code === navCode}">{{item.label}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import constants from '@/commons/constants';
import { packSelectObjUtil } from '@/commons/utils';
import { mapState } from 'vuex';
import { queryAssociatel, queryRecommends } from '@/api/uni.api';
export default {
    data () {
        return {
            input: '',
            timeout: null,
            courseType: packSelectObjUtil(constants.COURSE_TYPE)
        };
    },
    computed: {
        ...mapState({
            fixHeader: state => {
                return state.data.fixHeader;
            },
            showNav: state => {
                return state.data.showNav;
            },
            navCode: state => {
                return state.data.navCode;
            }
        })
    },
    methods: {
        queryAssociatelFn (queryString, cb) {
            if (queryString) {
                queryAssociatel(this.input).then((res) => {
                    let { code, data } = res;
                    if (code === 0 && data) {
                        let restaurants = this.filterData2(data);
                        let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;

                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(() => {
                            // 调用 callback 返回建议列表的数据
                            cb(results);
                        }, 1500 * Math.random());
                    }
                });
            } else {
                queryRecommends().then((res) => {
                    let { code, data } = res;
                    if (code === 0 && data) {
                        let restaurants = this.filterData(data);
                        cb(restaurants);
                    }
                });
            }
        },
        createFilter (queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
            };
        },
        filterData (arr) {
            let array = [];
            arr.forEach(element => {
                let obj = {};
                obj.value = element.recommendWords;
                obj.label = element.recommendWords;
                array.push(obj);
            });
            return array;
        },
        filterData2 (arr) {
            let array = [];
            arr.forEach(element => {
                let obj = {};
                obj.value = element;
                obj.label = element;
                array.push(obj);
            });
            return array;
        },
        handleSelect (item) {
            this.input = item.value;
            this.searchArticle();
        },
        searchArticle () {
            if (this.input.length > 0) {
                this.$store.commit('search', {
                    serarchVal: this.input
                });
                this.$store.commit('navCode', {
                    navCode: 'H'
                });
                this.$router.push({
                    path: `/article/search/${this.input}`
                });
            }
        },
        goHome () {
            this.$store.commit('navCode', { navCode: 'H' });
            this.$router.push('/');
        },
        routerList (code) {
            let path = '/';
            if (code !== 'H') {
                path = '/article/list';
            }
            this.$store.commit('navCode', { navCode: code });
            this.$router.push({
                path,
                query: {
                    code
                }
            });
        }
    },
    mounted () {
    }
};
</script>
<style lang="scss" scoped>
$w: 1120px;
$flex: flex;
@mixin boxsizing {
    box-sizing: border-box;
}

.header-wrap {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    background: #fff;
    /deep/ .el-input-group__append,
    /deep/.el-input-group__prepend {
        background-color: #ff454b;
        border-color: #ff454b;
    }
    /deep/ .el-input-group__append .el-button {
        color: #fff;
    }

    /deep/ .el-input.is-active .el-input__inner,
    /deep/ .el-input__inner:focus {
        border-color: #ff454b;
    }
    width: 100%;
    border-bottom: 1px solid rgba(245, 245, 245, 1);
    padding-top: 20px;
    @include boxsizing;
    .header {
        width: $w;
        margin: 0 auto;
        display: $flex;
        justify-content: space-between;
        .left {
            overflow: hidden;
            display: $flex;
            align-items: center;
            cursor: pointer;
            img {
                width: 108px;
            }
            span {
                color: #e0e0e0;
                margin: 0 18px;
            }
            b {
                color: #333;
                font-weight: normal;
                font-size: 16px;
                line-height: 22px;
            }
        }
        .right {
            .inline-input {
                width: 100%;
            }
        }
    }
}

.fixHeader {
    position: fixed;
    top: 0;
    transition: all ease .3s;
}

.ak-nav {
    margin: 0 auto;
    margin-top: 32px;
    width: 1120px;
    .nav {
        display: flex;
        li {
            margin: 0 48px 0 0;
            span {
                cursor: pointer;
                color: #666;
                font-size: 16px;
                text-decoration: none;
                padding: 0 0 10px;
                display: block;
                position: relative;
                &:hover {
                    color: #ff454b;
                }
                &.is-active {
                    color: #ff454b;
                    font-weight: bold;
                    &:before {
                        position: absolute;
                        content: "";
                        left: 50%;
                        bottom: 0;
                        margin-left: -10px;
                        width: 20px;
                        height: 2px;
                        background: #ff454b;
                    }
                }
            }
        }
    }
}
</style>
